export const Item = ({ image, alt, pabellon, stand }) => {
    const handleDragStart = (e) => e.preventDefault()

    return (
        <div className="max-w-[150px] max-h-[180px] h-full m-auto flex flex-col items-center justify-center px-4">
            <div className="min-h-[100px] flex items-center justify-center">
                <img src={`/${image}`} alt={alt} onDragStart={handleDragStart} />
            </div>
            <p className="m-0 text-black font-normal text-xs">
                Pabellon: <strong className="font-bold">{pabellon}</strong>
            </p>
            <p className="m-0 text-black font-normal text-xs">
                stand: <strong className="font-bold">{stand}</strong>
            </p>
        </div>
    )
}
